import { useEffect, useState } from "react";
import api from "@/lib/api";

/** Commodity names that have real rates (most widely reported first), for pick-lists. */
export default function useCommodities() {
  const [names, setNames] = useState([]);
  useEffect(() => {
    api.get("/rates/state-commodities").then(({ data }) => setNames((data.items || []).map((i) => i.commodity))).catch(() => {});
  }, []);
  return names;
}
